"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promotionKeys = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var promotionKeys = (0, _keyMirror.default)({
  BRAZIL: null,
  HSFS_SEED: null,
  HSFS_SERIES_A: null,
  HSFX_ENTREPRENEUR: null,
  HSFX_BOOTSTRAP: null,
  LATAM_ES: null,
  SERVICE_PRO_ONBOARDING: null,
  SALES_PRO_ONBOARDING: null,
  MARKETING_BASIC_TO_PRO: null,
  NO_PROMOTION: null
});
exports.promotionKeys = promotionKeys;